function getInititals(name) {
    var initials = name
    if (name && name.length > 2) {
        var initials = name.match(/\b\w/g) || []
        initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase()
    }
    return initials
}

export function Avatar({ color, name }) {
    return (
        <div className={(color ? "bg-" + color + "300 " + " text-" + color + "-800 " : "bg-slate-500 text-slate-800 ") + " cursor-pointer  rounded-full inline-flex items-center align-middle justify-center font-bold text-xs w-7 h-7 md:h-8 md:w-8"}>
            {getInititals(name)}
        </div>
    )
}